module.exports = __webpack_public_path__ + "static/media/jjPie.778b96b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jjPie.png
// module id = 659
// module chunks = 0 1